<template>
  <v-data-table
    id="duplicates-table"
    :headers="headers"
    :items="duplicates"
  >
    <template #[`item.view`]="{ item }">
      <v-icon
        style="cursor: pointer"
        class="mr-2"
        @click="_ => viewParty(item)"
      >
        preview
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'PartyDuplicates',

  props: {
    duplicates: {
      default: _ => ([]),
      type: Array,
    },
  },

  data () {
    return {
      headers: [
        { text: 'First name', value: 'first_name' },
        { text: 'Middle name', value: 'middle_name' },
        { text: 'Last name', value: 'last_name' },
        { text: 'Date of birth', value: 'dob' },
        { text: 'A#', value: 'a_number' },
        { text: 'SSN', value: 'ssn' },
        { sortable: false, text: 'View', value: 'view' },
      ],
    }
  },

  methods: {
    viewParty (party) {
      const route = this.$router.resolve({ name: 'partyEdit', params: { id: party.id } })
      window.open(route.href, '_blank')
    },
  },
}
</script>
